import { render } from "./SimpleForm.vue?vue&type=template&id=08f7e14a"
import script from "./SimpleForm.vue?vue&type=script&lang=js"
export * from "./SimpleForm.vue?vue&type=script&lang=js"

import "./SimpleForm.vue?vue&type=style&index=0&id=08f7e14a&lang=css"
script.render = render

export default script